import { Link } from "react-router-dom";
import { Star } from "lucide-react";
import REVIEWS from "@/lib/reviewsData";

export default function ReviewsSection({ sectionId = "flowlux-reviews", limit }) {
    const items = limit ? REVIEWS.slice(0, limit) : REVIEWS;
    return (
        <section
            id={sectionId}
            className="bg-flow-surface border-t border-flow-line scroll-mt-24"
            data-testid="section-reviews"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 md:py-24">
                <div className="text-left md:text-center">
                    <h2 className="text-3xl md:text-4xl lg:text-5xl tracking-tight text-flow-ink" style={{ fontWeight: 200 }}>
                        FlowLux Reviews
                    </h2>
                    <div className="mt-6 flex items-center gap-3 md:justify-center" data-testid="reviews-google-row">
                        <div className="flex items-center gap-[2px]">
                            {[0, 1, 2, 3, 4].map((i) => (
                                <Star key={i} size={16} className="text-[#FBBC05]" fill="#FBBC05" strokeWidth={0} />
                            ))}
                        </div>
                        <span className="text-sm text-flow-ink">250+ 5 Star Reviews</span>
                    </div>
                </div>

                <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="reviews-grid">
                    {items.map((r, i) => (
                        <ReviewCard key={i} review={r} index={i} />
                    ))}
                </div>

                <div className="mt-12 flex flex-col items-start md:items-center gap-3" data-testid="reviews-cta-wrap">
                    <Link to="/reviews" className="fl-btn-ghost text-sm" data-testid="reviews-cta-all">
                        See all FlowLux reviews
                    </Link>
                    <Link to="/review" className="fl-btn-gold text-sm" data-testid="reviews-cta">
                        <Star size={14} fill="currentColor" strokeWidth={0} />
                        Leave a FlowLux Review
                    </Link>
                    <p className="text-[11px] tracking-[0.18em] uppercase text-flow-muted">
                        Get 10% off your next FlowLux toilet
                    </p>
                </div>
            </div>
        </section>
    );
}

export function ReviewCard({ review: r, index }) {
    const rating = r.rating || 5;
    return (
        <div
            className="bg-[#FFFBEB] border border-[#F4D58A] p-5 rounded-sm"
            data-testid={`review-card-${index}`}
        >
            <div className="flex items-center gap-1.5">
                {[0, 1, 2, 3, 4].map((s) => (
                    <Star
                        key={s}
                        size={12}
                        className={s < rating ? "text-[#D6A437]" : "text-[#E5D9B8]"}
                        fill={s < rating ? "#D6A437" : "#E5D9B8"}
                        strokeWidth={0}
                    />
                ))}
            </div>
            <div className="mt-3 flex items-baseline justify-between gap-3">
                <div className="text-sm text-flow-ink" style={{ fontWeight: 400 }}>{r.name}</div>
                <div className="text-[10px] tracking-[0.18em] uppercase text-flow-muted">{r.date}</div>
            </div>
            <div className="mt-1 text-[11px] tracking-[0.15em] uppercase text-flow-blue">{r.product}</div>
            <p className="mt-3 text-xs text-flow-ink leading-relaxed">{r.body}</p>
        </div>
    );
}
